// src/ProtectedRoute.js

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Helper function to check if the password is "expired" (older than 1 year)
// We also check for the specific year 2000 that we set for new users.
const isPasswordExpired = (lastChangeDate) => {
    if (!lastChangeDate) return true;
    const lastChange = new Date(lastChangeDate);
    if (lastChange.getFullYear() === 2000) return true;
    
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    
    return lastChange < oneYearAgo;
};

const ProtectedRoute = () => {
    const { accessToken, user, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <div>Loading session...</div>;
    }

    if (!accessToken) {
        // If there's no token at all, always redirect to login
        return <Navigate to="/" replace />;
    }

    // --- THIS IS THE NEW "TRAP" LOGIC ---
    // Check if the user object is loaded and if a password change is required
    const passwordChangeRequired = user && (user.is_first_login || isPasswordExpired(user.last_password_change));

    if (passwordChangeRequired && location.pathname !== '/change-password') {
        // If they MUST change their password but are trying to go somewhere else,
        // force them to the change password page.
        return <Navigate to="/change-password" replace />;
    }
    // --- END OF NEW LOGIC ---

    // If they have a token and don't need to change their password (or are already on the right page), let them through.
    return <Outlet />;
};

export default ProtectedRoute;